import React from 'react';
import PropTypes from 'prop-types';
import { sampleSize } from 'lodash';
import { translate as t } from '../../lib/I18n';
import BatteryIcon from '../icons/BatteryIcon';
import BulbIcon from '../icons/BulbIcon';
import KettleIcon from '../icons/KettleIcon';
import MicrowaveIcon from '../icons/MicrowaveIcon';
import TVIcon from '../icons/TVIcon';
import WashingMachineIcon from '../icons/WashingMachineIcon';

const formatValue = value => (parseFloat(value) > 10.0 ? Math.round(parseFloat(value)) : value);

const CarbonFootprintModalAlternativeInfoSection = ({ carbonCalculationData }) => {
    const { bulb, fullyChargingSmartphones, kettle, microwave, savedCO2e, tv, washingMachine } = carbonCalculationData;

    const renderAlternativeInfoCards = () => {
        const alternativeInfoCardsConfig = [
            {
                iconComponent: <BatteryIcon />,
                title: t('carbonFootprint.modal.alternative.card.battery.title'),
                info: t('carbonFootprint.modal.alternative.card.battery.info', {
                    value: formatValue(fullyChargingSmartphones),
                }),
                value: fullyChargingSmartphones,
            },
            {
                iconComponent: <WashingMachineIcon />,
                title: t('carbonFootprint.modal.alternative.card.washingMachine.title'),
                info: t('carbonFootprint.modal.alternative.card.washingMachine.info', {
                    value: formatValue(washingMachine),
                }),
                value: washingMachine,
            },
            {
                iconComponent: <TVIcon />,
                title: t('carbonFootprint.modal.alternative.card.tv.title'),
                info: t('carbonFootprint.modal.alternative.card.tv.info', { value: formatValue(tv) }),
                value: tv,
            },
            {
                iconComponent: <KettleIcon />,
                title: t('carbonFootprint.modal.alternative.card.kettle.title'),
                info: t('carbonFootprint.modal.alternative.card.kettle.info', { value: formatValue(kettle) }),
                value: kettle,
            },
            {
                iconComponent: <BulbIcon />,
                title: t('carbonFootprint.modal.alternative.card.bulb.title'),
                info: t('carbonFootprint.modal.alternative.card.bulb.info', { value: formatValue(bulb) }),
                value: bulb,
            },
            {
                iconComponent: <MicrowaveIcon />,
                title: t('carbonFootprint.modal.alternative.card.microwave.title'),
                info: t('carbonFootprint.modal.alternative.card.microwave.info', { value: formatValue(microwave) }),
                value: microwave,
            },
        ];

        const notNullableCards = alternativeInfoCardsConfig.filter(({ value }) =>
            value > 1.0,
        );

        const randomlyPickedCards = sampleSize(notNullableCards, 3);

        return randomlyPickedCards.map(({ iconComponent, title, info }) => (
            <li
                className={`carbon-footprint-modal__alternative--card carbon-footprint-modal__alternative--card-${notNullableCards.length}`}
                key={ title }
            >
                <div className="carbon-footprint-modal__alternative--card-img-container">
                    { iconComponent }
                </div>
                <p className="carbon-footprint-modal__alternative--card-title">{ title }</p>
                <p className="carbon-footprint-modal__alternative--card-info">{ info }</p>
            </li>
        ));
    };

    return (
        <div>
            <h4 className="carbon-footprint-modal__title">
                { t('carbonFootprint.modal.alternative.info.title', { savedCO2e }) }
            </h4>
            <ul className="carbon-footprint-modal__alternative--cards-container">
                { renderAlternativeInfoCards() }
            </ul>
        </div>
    );
};

CarbonFootprintModalAlternativeInfoSection.propTypes = {
    carbonCalculationData: PropTypes.object.isRequired,
};

CarbonFootprintModalAlternativeInfoSection.defaultProps = {
    carbonCalculationData: {},
};

export default CarbonFootprintModalAlternativeInfoSection;



// WEBPACK FOOTER //
// ./src/components/carbonFootprint/CarbonFootprintModalAlternativeInfoSection.js